<style lang="scss">

</style>

<template>
  <!-- eslint-disable -->
  <div class="post-search-page mb-4">
    <section class="mb-2" v-if="showPrintButtons()">
      <print-on-site-btn @pdf-generated="getPost()"></print-on-site-btn>
    </section>

    <h3>{{ pageTitle }}</h3>

    <section class="my-2">
      <h4>Filters</h4>

      <div class="row">
        <section class="col-3">
          <label>{{'prisoner' | term(true)}} Number</label>
          <b-form-input
            @keyup.enter="searchPost()"
            @input="updateFilter('prisonerNumber', $event.toUpperCase())"
            :value="filters.prisonerNumber"
            class="mb-1" :placeholder="'Enter ' + $options.filters.term('prisoner') + ' number'"
          />
        </section>

        <section class="col-3">
          <label>External Contact Email <small>( full email needed )</small></label>
          <b-form-input
            @keyup.enter="searchPost()"
            @input="updateFilter('visitorEmail', $event)"
            :value="filters.visitorEmail"
            type="email"
            class="mb-1" placeholder="Enter external contact email"
          />
        </section>

        <section class="col-3" v-if="isPageType('physical')">
          <label>Delivery Status</label>
          <b-form-select @change="updateFilter('deliveryStatus', $event, true)" :value="filters.deliveryStatus" class="mb-2">
            <b-form-select-option value="">All</b-form-select-option>
            <b-form-select-option value="sentForPrinting">Sent for Printing</b-form-select-option>
            <b-form-select-option value="dispatched">Dispatched</b-form-select-option>
            <b-form-select-option value="delivered">Delivered</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-3" v-if="is_clinician">
          <label>Approval Status</label>
          <b-form-select @change="updateFilter('status', $event, true)" :value="filters.status" class="mb-2">
<!--            <b-form-select-option value="">All</b-form-select-option>-->
            <b-form-select-option v-for="status in approvalStatuses" :key="status.value"
                                  :value="status.value">{{status.text}}</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-3" v-if="is_clinician">
          <label>Post Type</label>
          <b-form-select @change="updateFilter('postType', $event, true)" :value="filters.postType" class="mb-2">
                        <b-form-select-option value="">All</b-form-select-option>
                        <b-form-select-option value="Digital">Digital</b-form-select-option>
                        <b-form-select-option value="Physical">Physical</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-3">
          <label>Status</label>
          <b-form-select @change="updateFilter('status', $event, true)" :value="filters.status" class="mb-1">
            <b-form-select-option value="">All Post</b-form-select-option>
            <b-form-select-option value="Approved">Approved</b-form-select-option>
            <b-form-select-option value="AwaitingConfirmation">Needs Approval</b-form-select-option>
            <b-form-select-option value="Rejected">Rejected</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-3">
          <label>Sort</label>
          <b-form-select @change="updateFilter('sort', $event, true)" :value="filters.sort" class="mb-1">
            <b-form-select-option value="updated_at">Updated (Oldest First)</b-form-select-option>
            <b-form-select-option value="-updated_at">Updated (Newest First)</b-form-select-option>
            <b-form-select-option value="prisoner_number">{{ $options.filters.term('prisoner') | capEachWord }} Number (A-Z)</b-form-select-option>
            <b-form-select-option value="-prisoner_number">{{ $options.filters.term('prisoner') | capEachWord }} Number (Z-A)</b-form-select-option>
            <b-form-select-option value="visitor.firstname">Visitor Name (A-Z)</b-form-select-option>
            <b-form-select-option value="-visitor.firstname">Visitor Name (Z-A)</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-3">
          <label>From Date</label>
          <b-form-datepicker @input="updateFilter('after', $event, true)" :value="filters.after" locale="en-uk"
                             today-button
                             reset-button
                             close-button
                             :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          ></b-form-datepicker>
        </section>

        <section class="col-3">
          <label>End Date</label>
          <b-form-datepicker @input="updateFilter('before', $event, true)" :value="filters.before" locale="en-uk"
                             today-button
                             reset-button
                             close-button
                             :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          ></b-form-datepicker>
        </section>

        <!--        <div class="ui-spacer"></div>-->

        <section class="col align-items-center d-flex" style="margin-top: 7px">
          <div class="ui-spacer"></div>
          <b-button @click="clearFilters()">Clear filters</b-button>
          <b-button class="btn-success ml-1" @click="searchPost()">Search</b-button>
        </section>
      </div>
    </section>

    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          hover
          :items="post"
          :fields="headers"
          :current-page="currentPage"
          :per-page="0"
        >
          <template #cell(visitorName)="data">
            {{data.item.visitor.firstname}} {{data.item.visitor.lastname}}
          </template>
          <template #cell(prisonerName)="data">
            {{data.item.contact.firstname}} {{data.item.contact.lastname}}
          </template>
          <template #cell(status)="data">
            {{ data.item.status === 'AwaitingConfirmation' ? 'Needs Approval' : data.item.status }}
          </template>
          <template #cell(updated_at)="data">
            {{data.item.updated_at | formatDateTime}}
          </template>
          <template #cell(deliveryStatus)="data">
            {{getDeliveryStatusFromPost(data.item)}}
          </template>
          <template #cell(printStatus)="data">
            {{getPrintStatusFromPost(data.item)}}
          </template>
          <template #cell(clinician_assigned)="data">
            {{data.item.clinician_assigned ? data.item.clinician_assigned.name : '-'}}
          </template>
          <template #cell(reviewed_by)="data">
            {{ getReviewedBy(data.item) }}
          </template>

          <template #cell(actions)="data">
            <router-link :to="{ name: 'post-view', params: { id: data.item._id } }" class="font-weight-bold d-block text-nowrap">
              View
            </router-link>
          </template>
        </b-table>
        <b-row class="p-1">
          <b-col md="6" class="m-1" v-if="totalRows > filters.limit">
            <b-pagination :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No post to show</p>
        </b-row>
      </section>
    </b-card>
  </div>
  <!-- eslint-enable -->
</template>

<script>
  import { mapState } from 'vuex';
  import StringUtils from '@/util/StringUtils';
  import HelperService from '../../services/HelperService';
  import PostService from '../../services/PostService';
  import PrintOnSiteBtn from '../../components/printQueue/PrintOnSiteBtn.vue';

  export default {
    name: 'PostSearch',
    components: {
      PrintOnSiteBtn,
    },
    data() {
      return {
        helperService: new HelperService(),
        loading: true,
        approvalStatuses: [
          { text: 'Awaiting Confirmation', value: 'AwaitingConfirmation' },
          { text: 'Approved', value: 'Approved' },
          { text: 'Rejected', value: 'Rejected' },
          // { text: 'Archived', value: 'Archived' },
        ],
        headers: [
          { label: `${this.$options.filters.term('prisoner')} Number`, key: 'prisoner_number' },
          { label: `${this.$options.filters.term('prisoner')}'s Assigned Name`, key: 'prisonerName' },
          { label: 'External Contact', key: 'visitorName' },
          { label: 'Status', key: 'status' },
          { label: 'Updated', key: 'updated_at' },
          { label: 'Reviewed By', key: 'reviewed_by' },
          { label: '', key: 'actions' },
        ],
        post: [],
        currentPage: 1,
        totalRows: 10,
        pageType: '',
        pollInterval: null,
      };
    },
    computed: {
      ...mapState({
        digitalEnabled: state => state.auth.user.prison.purple_post_digital_enabled,
        printOnSite: state => state.auth.user.prison.purple_post_print_on_site,
        filters: state => state.postCard.filters,
        is_clinician: state => state.auth.user.is_clinician,
        user: state => state.auth.user,
      }),
      pageTitle() {
        let status = this.filters.deliveryStatus;
        if (this.filters.postType === 'Digital') {
          status = this.filters.status;
        }

        let title = this.filters.postType === 'Digital' ? 'All Digital Post' : 'All Post';
        if (status === 'sentForPrinting') {
          title = 'Post Sent for Printing';
        } else if (status === 'dispatched') {
          title = 'Dispatched Post';
        } else if (status === 'delivered') {
          title = 'Delivered Post';
        } else if (status === 'AwaitingConfirmation') {
          title = 'Digital Post Needing Approval';
        } else if (status === 'Approved') {
          title = 'Approved Digital Post'
        } else if (status === 'Rejected') {
          title = 'Rejected Digital Post';
        }

        return title;
      },
    },
    watch: {
      currentPage() {
        this.getPost();
      },
    },
    beforeDestroy() {
      clearInterval(this.pollInterval);
    },
    mounted() {
      this.$store.dispatch('postCard/resetFilters', {
        postType: this.filters.postType,
        deliveryStatus: this.filters.deliveryStatus,
        status: this.filters.status,
        sentForPrinting: this.filters.sentForPrinting,
      });

      this.setUpPageForType();
      this.getPost();
      // this.setUpPolling();
    },
    methods: {
      setUpPageForType() {
        if (this.filters.postType === 'Digital') {
          this.pageType = 'digital';
        }

        if (this.filters.postType === 'Physical') {
          this.pageType = this.printOnSite ? 'printOnSite' : 'physical';

          if (this.pageType === 'physical') {
            this.headers.push({ label: 'Delivery Status', key: 'deliveryStatus' });
            this.setDeliveryStatusFilters();
          } else { // printOnSite
            this.headers.splice(this.headers.length - 2, 0, { label: 'Print Status', key: 'printStatus' });
          }
        }

        if (!this.is_clinician) {
          this.headers.splice(this.headers.length - 2, 0, { label: 'Staff Assigned', key: 'clinician_assigned' });
        }
      },
      isPageType(type) {
        return this.pageType === type;
      },
      setDeliveryStatusFilters() {
        if (this.filters.deliveryStatus === 'delivered') {
          this.setDeliveryFilters(true, true, true);
        } else if (this.filters.deliveryStatus === 'dispatched') {
          this.setDeliveryFilters(true, true, false);
        } else if (this.filters.deliveryStatus === 'sentForPrinting') {
          this.setDeliveryFilters(true, false, false);
        } else if (this.filters.deliveryStatus === 'pending') {
          this.setDeliveryFilters(false, false, false);
        } else {
          this.setDeliveryFilters(null, null, null);
        }
      },
      setDeliveryFilters(print, dispatched, delivered) {
        this.updateFilter('delivered', delivered);
        this.updateFilter('dispatched', dispatched);
        this.updateFilter('sentForPrinting', print);
      },
      searchPost() {
        this.currentPage = 1;
        this.getPost();
      },
      getPost() {
        if (this.isPageType('physical')) {
          this.setDeliveryStatusFilters(); // update filters from delivery option
        }

        this.filters.printOnSite = this.printOnSite || false;

        if (this.is_clinician) {
          this.filters.clinicianId = this.user.user_id;
        }

        this.updateFilter('skip', (this.currentPage - 1) * this.filters.limit);

        PostService.getAll(this.filters).then(res => {
          this.loading = false;
          this.post = res.data.data;
          this.totalRows = res.data.count;
        }).catch(err => {
          console.log('Error getting post ', err);
          this.$toast.error('Could not get post, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      getDeliveryStatusFromPost(post) {
        return PostService.getDeliveryStatusTextFromPostOptions(post.sent_for_printing, post.dispatched, post.delivered);
      },
      getPrintStatusFromPost(post) {
        return PostService.getPrintStatusTextFromPostOptions(post.sent_for_printing, post.dispatched, post.delivered);
      },
      getReviewedBy(post) {
        if (post.status === 'Requested' || post.status === 'AwaitingConfirmation') {
          return '-'
        }
        if (post.reviewer && post.reviewer.name) {
          return StringUtils.toTitleCase(post.reviewer.name);
        }
        return 'System';
      },
      updateFilter(filterName, e, refresh) {
        this.$store.commit('postCard/SET_FILTER_ITEM', { name: filterName, value: e });

        if (refresh) {
          this.searchPost();
        }
      },
      clearFilters() {
        this.$store.dispatch('postCard/clearFilters');
        this.searchPost();
      },
      setUpPolling() {
        if (this.pollInterval) {
          clearTimeout(this.pollInterval);
        }
        this.pollInterval = setInterval(() => {
          this.getPost();
        }, 10 * 1000);
      },
      showPrintButtons() {
        const filters = this.filters.status === 'Approved';
        return this.isPageType('printOnSite') && filters && !this.is_clinician;
      },
    },
  };
</script>
